   document.addEventListener("click", function (e) {
  const button = e.target.closest(".offer_code");
  if (!button) return; // exit if not clicked on .offer_code

  const copiedText = button.getAttribute("data-clipboard-text");
  const copiedStatus = button.querySelector(".copyStatus");

  copyToClipboard(copiedText);

  if (copiedStatus) {
    copiedStatus.textContent = "Copied!";
    copiedStatus.style.display = "inline-block";

    setTimeout(() => {
      copiedStatus.style.display = "none";
    }, 1500);
  }
});

function copyToClipboard(text) {
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextArea);
}



 